export const GET_HOST_ORDER_DETAILS = "GET_HOST_ORDER_DETAILS"
export const GET_HOST_ORDER_DETAILS_SUCCESSFUL = "GET_HOST_ORDER_DETAILS_SUCCESSFUL"
export const GET_HOST_ORDER_DETAILS_FAILED = "GET_HOST_ORDER_DETAILS_FAILED"
